import { Component } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AppConstants } from 'src/app/app-constants';
import { AppConfigService } from 'src/app/config/appconfig.service';
import { UserDetails } from 'src/app/models/user-details.model';
import { StorageService } from 'src/app/services/storage.service';

@Component({
  selector: 'app-payment',
  templateUrl: './payment.component.html',
  styleUrls: ['./payment.component.scss']
})
export class PaymentComponent {

  userInfo: UserDetails;
  selectedOption: any;
  isPartialAllowed = false;
  isPendingPolicy = false;
  paymentAmountLimit = AppConstants.EFT_LIMIT;
  cardPaymentAmountLimit = AppConstants.CARD_LIMIT;

  isGracePayment = false;
  maxPartialPaymentAmount = 1;

  myform: FormGroup;

  constructor(private router: Router, private fb: FormBuilder, private storageService: StorageService, private config: AppConfigService) {
    this.isGracePayment = this.config.getIsGracePayment();
    let isPendingPolicy = this.storageService.getIsPendingPolicy();
    if(!this.isGracePayment && isPendingPolicy == null){
      this.router.navigateByUrl('/home');
    } else{
      this.isPendingPolicy = isPendingPolicy;
    }
    let userInfo = this.storageService.getUserInfo();
    if(userInfo == null){
      this.router.navigateByUrl('/policy-search');
    } else{
      this.userInfo = userInfo;
    }
    let partialAllowed = this.userInfo?.allowPartialPayment;
    if(partialAllowed == null){
      this.onBack();
    } else{
      this.isPartialAllowed = partialAllowed;
    }

    if(this.isPartialAllowed){
     this.maxPartialPaymentAmount= this.userInfo.balance;
    }
    

    this.myform = this.fb.group({
      paymentOption: ['', [Validators.required]]
    });
  }

  ngOnInit(): void {
    this.myform.get('paymentOption').valueChanges.subscribe(value => {
      if (value == '2') {
        this.myform.addControl('paymentAmount', this.fb.control('', [Validators.required, Validators.min(1.00), 
          Validators.max(this.maxPartialPaymentAmount )]));
      } else {
        if (this.myform.contains('paymentAmount')) {
          this.myform.removeControl('paymentAmount');
        }
      }
    })
  }

  onSubmit() {
    if (this.isGracePayment || this.myform.valid || !this.isPartialAllowed) {
      let values = this.myform.value;
      let paymentAmount = 0;
      if(this.isGracePayment || !this.isPartialAllowed){
         paymentAmount = this.userInfo.balance;
      } else{
        if(values.paymentOption == '1'){
          if(this.userInfo.balance > this.paymentAmountLimit){
            paymentAmount = this.paymentAmountLimit;
          } else {
            paymentAmount = this.userInfo.balance;
          }
        } else if(values.paymentOption == '2'){
          paymentAmount = values.paymentAmount;
        }
      }
      this.storageService.setPaymentAmount(paymentAmount);
      this.router.navigateByUrl('/payment-method');
    } else {
      this.myform.markAllAsTouched();
      window.scrollTo(0, 0);
    }
  }

  onBack() {
    if (this.isGracePayment) {
      this.router.navigate(['/policy-found'], { fragment: 'grace-payment' });
    } else {
      this.router.navigateByUrl('/policy-found');
    }
  }

  onCancel() {
    if (this.isGracePayment) {
      this.router.navigate(['/policy-search'], { fragment: 'grace-payment' });
    }else {
      window.location.href = ' https://www.nationwide.com/personal/member-services/pay-bill?utm_campaign=pl-sitelink&utm_medium=Search&utm_source=Bing&utm_content=All:PL:REP:NA:NA&utm_term=www%20nation&&msclkid=74591eadb69016dcc7837bfa31491e5d&gclid=74591eadb69016dcc7837bfa31491e5d&gclsrc=3p.ds';
    }    
  }

}
